import { servidorNaApi } from '@/lib/loja-digital';
import { apiClient } from '../api/client';
import type { Category } from '@/types';

export type { Category };

export interface CategoryAPI {
  id: string;
  name: string;
  slug: string;
  description?: string;
  imageUrl?: string;
  bannerUrl?: string;
  order: number;
  isActive: boolean;
  parentCategoryId?: string;
  subcategories?: CategoryAPI[];
  productsCount: number;
  subcategoriesProductsCount: number;
}

export const categoryService = {
  async listByStore(storeId: string, parentId?: string, serverId?: string): Promise<Category[]> {
    const searchParams = new URLSearchParams();
    if (parentId) searchParams.set('parentId', parentId);
    const servidor = servidorNaApi(serverId);
    if (servidor) searchParams.set('serverId', servidor);
    const query = searchParams.toString();
    const response = await apiClient.get<{ categories: CategoryAPI[]; total: number }>(
      `/public/stores/${storeId}/categories${query ? `?${query}` : ''}`
    );
    
    // Mapear para o formato esperado pelo frontend
    return (response.categories || []).map((cat) => ({
      id: cat.id,
      name: cat.name,
      slug: cat.slug,
      description: cat.description || '',
      image: cat.imageUrl || cat.bannerUrl || 'https://placehold.co/600x400?text=Categoria',
      productCount: cat.productsCount + cat.subcategoriesProductsCount,
    }));
  },
};
